import { createTheme } from '@mui/material/styles';

const V3Theme = createTheme({
  palette: {
    primary: {
      main: '#56A6C3',
      light: '#7CBDD5',
      dark: '#3A8AAA',
      contrastText: '#fff',
    },
    secondary: {
      main: '#838383',
      light: '#ADADAD',
      dark: '#5A5A5A',
      contrastText: '#fff',
    },
    error: {
      main: '#ED4D29',
    },
    success: {
      main: '#3A8F5C',
    },
    warning: {
      main: '#D4930D', // Ticket d'or (ocre DS V1)
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1B2E28',
      secondary: '#6B6B6B',
      disabled: '#94A8A0',
    },
    divider: '#E2EDE7',
    border: {
      main: '#E2EDE7',
    },
    // Couleurs custom pour landing-consumer
    accent: {
      main: '#2EA9C7', // bleu MOBIUSpack
    },
  },
  typography: {
    fontFamily: '"Inter", sans-serif',
    allVariants: {
      fontFamily: '"Inter", sans-serif',
    },
    h1: {
      fontSize: 28,
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: 24,
      fontWeight: 700,
    },
    h3: {
      fontSize: 20,
      fontWeight: 700,
    },
    h4: {
      fontSize: 15,
      fontWeight: 600,
    },
    h5: {
      fontSize: 12,
      color: '#857F7F',
      fontWeight: 400,
    },
    body1: {
      fontSize: 14,
      fontWeight: 400,
    },
    body2: {
      fontSize: 12,
      fontWeight: 400,
      color: '#857F7F',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
    monorama: {
      fontFamily: '"Monorama", "SF Mono", monospace',
      fontWeight: 600,
      letterSpacing: '-0.2px',
      fontSize: 14,
    },
  },
  shape: {
    borderRadius: 8,
    card: 16,
    pill: 999,
    input: 10,
  },
  spacing: 8,
  shadows: [
    'none',
    '0 1px 3px rgba(27,46,40,0.06), 0 8px 24px rgba(27,46,40,0.04)', // card
    '0 2px 8px rgba(46,169,199,0.30)', // btn
    '0 2px 8px rgba(212,147,13,0.40)', // warm
    '0px 0px 10px rgba(0,0,0,0.08)',
    '0px 2px 8px rgba(0,0,0,0.15)',
    '0px 0px 10px rgba(0,0,0,0.15)',
    ...Array(18).fill('none'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
          },
        },
        contained: {
          boxShadow: '0px 0px 10px rgba(0,0,0,0.15)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0px 0px 10px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        autoHideDuration: 5000,
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'monorama' },
          style: {
            fontFamily: '"Monorama", "SF Mono", monospace',
            fontWeight: 600,
            letterSpacing: '-0.2px',
            fontSize: 14,
          },
        },
      ],
    },
  },
});

export default V3Theme;
